import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopOrders from '../../../components/Shops/Orders'

const ShopOrderPage = (): ReactElement => {
  return (
    <Layout >
      <ShopOrders />
    </Layout>
  )
}

export default ShopOrderPage
